// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WuHt","col":"styles_col__3Hghh"};